import React from 'react'
import { scaleDimensions, getHexColor } from '../utils'
import { OneColorLogoProps } from './LogoTypes'

export const AppleStoreMinimalLogo: React.FC<OneColorLogoProps> = ({ height = 32, color = 'white', className }) => {
  const { width: scaledWidth, height: scaledHeight } = scaleDimensions(height, 32, 32)
  const hex = getHexColor(color)

  return (
    <svg
      className={className}
      width={scaledWidth}
      height={scaledHeight}
      viewBox="0 0 20 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.9865 8.68242C18.8468 8.79043 16.3798 10.1754 16.3798 13.2549C16.3798 16.8168 19.5189 18.077 19.6129 18.1082C19.5984 18.185 19.1142 19.8339 17.9578 21.5141C16.9267 22.9926 15.8498 24.4688 14.2116 24.4688C12.5734 24.4688 12.1518 23.5207 10.2606 23.5207C8.41758 23.5207 7.76229 24.5 6.26379 24.5C4.7653 24.5 3.71973 23.1319 2.51756 21.4517C1.12507 19.4787 0 16.4136 0 13.5045C0 8.83843 3.04517 6.36379 6.04215 6.36379C7.6346 6.36379 8.96204 7.40549 9.96184 7.40549C10.9135 7.40549 12.3975 6.30138 14.2092 6.30138C14.8958 6.30138 17.3628 6.36379 18.9865 8.68242ZM13.3491 4.32598C14.0984 3.44029 14.6284 2.21137 14.6284 0.982448C14.6284 0.812031 14.6139 0.639214 14.5826 0.5C13.3636 0.545605 11.9133 1.30888 11.0387 2.31938C10.3521 3.09706 9.71129 4.32598 9.71129 5.57171C9.71129 5.75893 9.74261 5.94614 9.75706 6.00615C9.83416 6.02055 9.95943 6.03735 10.0847 6.03735C11.1785 6.03735 12.5541 5.30768 13.3491 4.32598Z"
        fill={hex}
      />
    </svg>
  )
}
